// The mobile drawer is a showModal() <dialog>, so it sits in the top layer and the
// Klevu popup renders behind it. Klevu captures ONE results node at init
// (klevu-overrides-js.liquid `searchBoxTarget`), so the whole popup element is
// relocated into the drawer rather than standing up a second results surface.
;(() => {
  const drawer = document.querySelector('modal-dialog#mobile-menu-drawer')
  const slot = document.querySelector('[data-drawer-search-results]')
  const input = document.querySelector('.mobilemenu__search-input')
  const popup = document.querySelector('klevu-instant-search-popup')
  if (!drawer || !slot || !input || !popup) return

  const home = { parent: popup.parentNode, next: popup.nextSibling }

  const adopt = () => {
    if (popup.parentNode === slot) return
    slot.appendChild(popup)
    popup.setAttribute('data-in-drawer', '')
  }

  const restore = () => {
    if (popup.parentNode !== slot) return
    popup.removeAttribute('data-in-drawer')
    home.parent.insertBefore(popup, home.next)
    input.value = ''
    // The popup's close path focuses its own `trigger` — the header magnifier, if it
    // was ever used. The drawer has already returned focus to its own trigger by now.
    popup.trigger = null
    popup.hide?.()
    // Otherwise the next drawer open shows the previous query's results and hides the nav.
    const results = popup.querySelector('.klevu-results')
    if (results) results.innerHTML = ''
  }

  input.addEventListener('focus', adopt)
  input.addEventListener('input', adopt)

  document
    .querySelector('[data-drawer-search-clear]')
    ?.addEventListener('click', () => {
      input.value = ''
      const results = popup.querySelector('.klevu-results')
      if (results) results.innerHTML = ''
      input.focus()
    })

  new MutationObserver(() => {
    if (!drawer.hasAttribute('open')) restore()
  }).observe(drawer, { attributes: true, attributeFilter: ['open'] })
})()
